/* CCC 2026-11-03 – Produktseite: Merken-Knopf, Versand und Lieferung zum Aufklappen, Tamper-Grösse zur Maschine.
   Modul zu assets/ccc28-extras.js (Kern, Texte in ccc28-text.js). Geladen von sections/ccc28-extras.liquid. */
(function () {
  var M = function (C) {
    var D = C.D, S = C.S, LANG = C.LANG, ROOT = C.ROOT, LB = C.LB, t = C.t, val = C.val, esc = C.esc, num = C.num, money = C.money, img = C.img, pub = C.pub;
    var lsGet = C.lsGet, lsSet = C.lsSet, ssGet = C.ssGet, ssSet = C.ssSet, HANDLE = C.HANDLE, HEART = C.HEART, XICON = C.XICON, KEY = C.KEY;
    var list = C.list, toggleItem = C.toggleItem, openDrawer = C.openDrawer, toast = C.toast, addToCart = C.addToCart, lock = C.lock;
    var lastFocus = null;
    /* ---------- Produktseite ---------- */
    function curVid() {
      var i = document.querySelector('block-buy-buttons input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var P = D.product;
      return i && i.value ? Number(i.value) : (P && P.vs[0] ? P.vs[0].id : null);
    }
    function curVariant() { var id = curVid(); return (D.product.vs || []).filter(function (v) { return v.id === id; })[0] || D.product.vs[0]; }
    var vHooks = [];
    function onVariant(fn) { vHooks.push(fn); }
    var lastVid = null;
    function fireVariant() { var id = curVid(); if (id === lastVid) return; lastVid = id; vHooks.forEach(function (f) { try { f(); } catch (e) {} }); }

    function productBtn() {
      var P = D.product, bb = document.querySelector('block-buy-buttons');
      if (!S.wl || !bb || bb.parentNode.querySelector('.ccc28-pb')) return;
      var row = document.createElement('div');
      row.className = 'ccc28-pb';
      row.innerHTML = '<button type="button" class="ccc28-pbtn" data-ccc28-h="' + esc(P.h) + '" data-ccc28-t="' + esc(P.t) + '" aria-pressed="false">' + HEART + '<span class="ccc28-pbtn__l">' + esc(t('save')) + '</span></button>' +
        '<button type="button" class="ccc28-lnk ccc28-pbtn__see" data-h="' + esc(P.h) + '" hidden>' + esc(t('see_list')) + ' ›</button>';
      bb.parentNode.insertBefore(row, bb.nextSibling);
      row.querySelector('.ccc28-pbtn').addEventListener('click', function (e) {
        var v = curVariant();
        toggleItem({ h: P.h, v: P.vs.length > 1 && v ? v.id : null, t: P.t, i: P.i, u: P.u }, e.currentTarget);
      });
      row.querySelector('.ccc28-pbtn__see').addEventListener('click', function () { openDrawer('own'); });
      onVariant(function () {
        /* gemerkte Variante nachführen, wenn die Kundschaft umstellt */
        var a = list(), it = a.filter(function (x) { return x.h === P.h; })[0], v = curVariant();
        if (it && P.vs.length > 1 && v && it.v !== v.id) { it.v = v.id; lsSet(KEY, a); }
      });
    }

    function shipping() {
      if (!S.ship) return;
      var P = D.product, bb = document.querySelector('block-buy-buttons');
      if (!bb || document.querySelector('.ccc28-ship')) return;
      var pre = {};
      try { pre = JSON.parse((document.getElementById('ccc27-preorder') || {}).textContent || '{}') || {}; } catch (e) { pre = {}; }
      var det = document.createElement('details');
      det.className = 'ccc28-ship';
      det.id = 'ccc-versand';
      det.innerHTML = '<summary class="ccc28-ship__s"><span>' + esc(t('ship_sum')) + '</span></summary><div class="ccc28-ship__b"></div>';
      var anchor = document.querySelector('.ccc28-pb') || bb;
      anchor.parentNode.insertBefore(det, anchor.nextSibling);
      function fill() {
        var v = curVariant(), sp = P.spv || (v && v.sp), pv = v ? pre[String(v.id)] : null;
        var li = [];
        if (sp) li.push(t('ship_sp'));
        else {
          li.push(t('ship_std', { p: String(S.shipp || '6.50'), f: String(S.shipf || '60') }));
          if (pv && pv.pre) li.push(t('ship_pre', { w: pv.ab ? t('ship_ab', { d: pv.ab }) : t('ship_when') }));
          else li.push(t('ship_time'));
          li.push(t('ship_multi'));
        }
        det.querySelector('.ccc28-ship__b').innerHTML = '<ul role="list">' + li.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' +
          '<a class="ccc28-ship__l" href="' + esc(ROOT + '/policies/shipping-policy') + '" target="_blank" rel="noopener">' + esc(t('ship_link')) + ' ›</a>';
        if (sp) det.open = true;
      }
      fill();
      onVariant(fill);
      det.addEventListener('toggle', function () { if (det.open) pub('ccc:versand_open', { handle: P.h }); });
      /* «Versandkosten» beim Preis öffnet die Angaben, statt die Seite zu wechseln */
      document.querySelectorAll('.product__policies a[href*="shipping-policy"]').forEach(function (a) {
        a.setAttribute('aria-controls', 'ccc-versand');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          det.open = true;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          det.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          try { det.querySelector('summary').focus({ preventScroll: true }); } catch (err) {}
        });
      });
    }

    /* Tamper: Grösse zur Maschine */
    function dias(s) {
      var out = [], re = /(\d{2}(?:[.,]\d{1,2})?)/g, m, str = String(s || '');
      while ((m = re.exec(str))) {
        var before = str.slice(Math.max(0, m.index - 1), m.index), after = str.charAt(m.index + m[1].length);
        if (/[\d.,]/.test(before) || /\d/.test(after)) continue;
        var x = parseFloat(m[1].replace(',', '.'));
        if (x < 44 || x > 70) continue;
        var pre = str.slice(Math.max(0, m.index - 6), m.index).toLowerCase();
        out.push({ x: x, bk: /(f(ü|u)r|for|pour|per|para)\s*$/.test(pre) });
      }
      return out;
    }
    function passform() {
      var P = D.product;
      if (!S.pf || !P.tamper || !D.pfl || !D.pfl.length) return;
      if (document.querySelector('.ccc28-pf')) return;
      var E = D.pfl.filter(function (e) { return e && e.n && e.a != null && e.b != null && e.s != null; }).map(function (e) { return { h: e.h, n: e.n, s: Number(e.s), a: Number(e.a), b: Number(e.b) }; });
      E.sort(function (x, y) { return (y.s - x.s) || String(x.n).localeCompare(String(y.n)); });
      if (!E.length) return;
      var SV = []; E.forEach(function (e) { if (SV.indexOf(e.s) < 0) SV.push(e.s); });
      var pD = dias(P.t);
      function vD(v) { var d = v && v.t !== 'Default Title' ? dias(v.t) : []; return d.length ? d : (P.vs.length === 1 ? pD : []); }
      if (!P.vs.some(function (v) { return vD(v).length; })) return;
      function cls(x) { var c = SV.filter(function (s) { return Math.abs(x - s) <= 0.8; }); return c.length === 1 ? c[0] : null; }
      function judge(e, ds) {
        var best = null, rank = { in: 3, bk: 2, has: 1, off: 0 };
        ds.forEach(function (d) {
          var k;
          if (d.bk) k = d.x === e.s ? 'bk' : (SV.indexOf(d.x) >= 0 ? 'off' : 'has');
          else if (d.x >= e.a - 0.005 && d.x <= e.b + 0.005) k = 'in';
          else { var c = cls(d.x); k = c === null || c === e.s ? 'has' : 'off'; }
          if (!best || rank[k] > rank[best.k]) best = { k: k, x: d.x };
        });
        return best;
      }
      var box = document.createElement('div');
      box.className = 'ccc28-pf';
      box.innerHTML = '<label class="ccc28-pf__h" for="ccc28-pf-sel">' + esc(t('pf_h')) + '</label>' +
        '<select class="ccc28-pf__sel" id="ccc28-pf-sel"><option value="">' + esc(t('pf_sel')) + '</option>' + E.map(function (e) { return '<option value="' + esc(e.h) + '">' + esc(e.n) + '</option>'; }).join('') + '</select>' +
        '<div class="ccc28-pf__r" aria-live="polite"></div>' +
        '<p class="ccc28-pf__ask">' + esc(t('pf_ask')) + ' <button type="button" class="ccc28-lnk" data-ccc-jackson="' + esc(t('pf_q')) + '">' + esc(t('pf_ask_b')) + ' ›</button></p>';
      var picker = document.querySelector('kit-variant-picker');
      var bb = document.querySelector('block-buy-buttons');
      if (picker && picker.parentNode) picker.parentNode.insertBefore(box, picker.nextSibling);
      else if (bb) bb.parentNode.insertBefore(box, bb);
      else return;
      var sel = box.querySelector('select'), res = box.querySelector('.ccc28-pf__r');
      /* Vorauswahl: zuletzt gewählter Siebträger, sonst das gemerkte Maschinenprofil (assets/ccc27-machine.js) */
      var saved = lsGet('ccc28-sieb', '');
      if (!saved) {
        var mp = (lsGet('ccc27-machine', null) || {}).p;
        if (mp && mp.k === 'm' && mp.d && !mp.si) {
          var vv = String(mp.v || '').toLowerCase(), cand = null;
          if (mp.g === 'e61') cand = 'e61-58';
          else if (vv === 'la marzocco' && mp.d === 58) cand = 'la-marzocco-58';
          else if (vv === 'lelit') cand = 'lelit-' + mp.d;
          else if (vv === 'gaggia' || vv === 'cimbali') cand = 'gaggia-cimbali-58';
          else if (vv === 'breville' || vv === 'sage') cand = 'breville-sage-54';
          else if (vv === 'la pavoni') cand = 'la-pavoni-' + mp.d;
          if (cand && E.some(function (e) { return e.h === cand; })) saved = cand;
        }
      }
      if (saved && E.some(function (e) { return e.h === saved; })) sel.value = saved;
      function range(e) { return e.a === e.b ? num(e.a) : num(e.a) + '–' + num(e.b); }
      function pick(target) {
        /* passende Variante wählen: nur die abweichende Option umstellen */
        var cur = curVariant(), co = String(cur.t).split(' / '), to = String(target.t).split(' / ');
        to.forEach(function (o, i) {
          if (o === co[i]) return;
          var inp = [].slice.call(document.querySelectorAll('kit-variant-picker input[type="radio"]')).filter(function (r) { return r.value === o; })[0];
          if (inp) { inp.click(); return; }
          [].slice.call(document.querySelectorAll('kit-variant-picker select')).forEach(function (s) {
            if ([].some.call(s.options, function (op) { return op.value === o; })) { s.value = o; s.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        });
      }
      function show() {
        var e = E.filter(function (x) { return x.h === sel.value; })[0];
        if (!e) { res.innerHTML = ''; box.classList.remove('is-set'); return; }
        box.classList.add('is-set');
        var html = '<p class="ccc28-pf__rec">' + esc(t('pf_rec', { n: e.n, r: range(e) })) + '</p>';
        var v = curVariant(), j = judge(e, vD(v));
        if (j) {
          var msg = j.k === 'in' ? t('pf_in', { x: num(j.x) }) : j.k === 'bk' ? t('pf_bk', { x: num(j.x) }) : j.k === 'off' ? t('pf_off', { x: num(j.x) }) : t('pf_has', { x: num(j.x) });
          html += '<p class="ccc28-pf__v is-' + j.k + '">' + (j.k === 'in' ? '<span class="ccc27-dot" aria-hidden="true"></span>' : '') + esc(msg) + '</p>';
          if (j.k === 'off' || j.k === 'has') {
            var co = String(v.t).split(' / ');
            var best = null;
            P.vs.forEach(function (w) {
              if (w.id === v.id || !w.a) return;
              var jw = judge(e, vD(w));
              if (!jw || (jw.k !== 'in' && jw.k !== 'bk')) return;
              var same = String(w.t).split(' / ').filter(function (o, i) { return o === co[i]; }).length;
              var sc = (jw.k === 'in' ? 10 : 5) + same;
              if (!best || sc > best.sc) best = { w: w, sc: sc };
            });
            if (best) {
              var lab = String(best.w.t).split(' / ').filter(function (o, i) { return o !== co[i]; }).join(' / ') || best.w.t;
              html += '<button type="button" class="ccc28-btn ccc28-pf__sw" data-vid="' + best.w.id + '">' + esc(t('pf_switch', { x: lab })) + '</button>';
            }
          }
        }
        res.innerHTML = html;
        var sw = res.querySelector('[data-vid]');
        if (sw) sw.addEventListener('click', function () {
          var w = P.vs.filter(function (x) { return String(x.id) === sw.getAttribute('data-vid'); })[0];
          if (w) { pick(w); setTimeout(fireVariant, 80); }
        });
      }
      sel.addEventListener('change', function () { lsSet('ccc28-sieb', sel.value); show(); pub('ccc:tamper_groesse', { sieb: sel.value }); });
      onVariant(show);
      show();
    }

    if (!D.product) return;
    productBtn();
    shipping();
    passform();
    lastVid = curVid();
    document.addEventListener('change', function () { setTimeout(fireVariant, 60); }, true);
    document.addEventListener('variant:change', function () { setTimeout(fireVariant, 60); });
    window.addEventListener('popstate', function () { setTimeout(fireVariant, 60); });
  };
  if (window.ccc28 && window.ccc28.started) M(window.ccc28);
  else (window.ccc28Mods = window.ccc28Mods || []).push(M);
})();
